import Bgwrapper from "./components/Bgwrapper";
export default function Wrapper({ children }) {
    return (
      <div className="w-[390px] h-[844px] mx-auto flex flex-col items-center bg-white relative overflow-hidden">
        {children}
        <Bgwrapper />
      </div>
    );
  }
  